<template>
    <div class="md-layout" v-if="screenVisible">
        <!-- Product Info -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-2">
                    <h4 class="title pt-1" v-if="!productLoading">
                        {{ product.name }}
                    </h4>
                </md-card-header>
                <md-card-content class="pb-2">
                    <div class="md-layout" v-if="!productLoading">
                        <div
                            class="md-layout-item md-size-10 md-large-size-10 md-medium-size-20 md-small-size-30 md-xsmall-size-100 image-content"
                        >
                            <i
                                v-if="!product.image_url"
                                class="far fa-times-circle"
                                style="font-size: 120px"
                            ></i>
                            <md-content v-else class="md-elevation-1">
                                <img v-bind:src="product.image_url" />
                            </md-content>
                        </div>
                        <div
                            class="md-layout-item md-layout md-alignment-top-left list-content"
                        >
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Código:</b>
                                <span class="item-content">{{
                                    product.external_common_id
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Descrição:</b>
                                <span class="item-content">{{
                                    product.name
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Referência:</b>
                                <span class="item-content">{{
                                    product.reference_number
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Fornecedor:</b>
                                <span class="item-content">{{
                                    product.brand
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Status:</b>
                                <span class="item-content">{{
                                    currentStatus
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Cor:</b>
                                <span class="item-content">{{
                                    product.color && product.color.name
                                        ? product.color.name
                                        : 'SEM COR'
                                }}</span>
                            </div>
                            <div
                                class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                            >
                                <b>Voltagem:</b>
                                <span class="item-content">{{
                                    currentVoltage
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="text-center mt--2 pb-2" v-else>
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <!--Simulations -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-2">
                    <h4 class="title pt-1" v-if="!productLoading">
                        Simulações para {{ product.name }}
                    </h4>
                </md-card-header>
                <md-card-content class="pb-2">
                    <md-table
                        :value="simulations.results"
                        :md-sort.sync="currentSort"
                        :md-sort-order.sync="currentSortOrder"
                        :md-sort-fn="customSort"
                        class="paginated-table table-striped table-hover"
                        v-if="!simulationsLoading"
                    >
                        <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                            @mouseenter="actionVisible = item.id"
                            @mouseleave="actionVisible = null"
                            class="simulation-row"
                            :class="{
                                'simulation-selected':
                                    simulationSelected &&
                                    simulationSelected.id == item.id
                            }"
                            @click="selectSimulation(item)"
                        >
                            <md-table-cell
                                v-for="column in Object.keys(columnNames)"
                                :md-label="columnNames[column]"
                                :md-sort-by="column"
                                :key="column"
                                :title="item[column]"
                            >
                                {{
                                    column == 'datetime_created'
                                        ? new Date(
                                              item[column]
                                          ).toLocaleString()
                                        : item[column]
                                }}
                            </md-table-cell>
                            <md-table-cell class="td-actions">
                                <div v-if="actionVisible == item.id">
                                    <md-button
                                        class="md-just-icon md-warning md-simple"
                                        @click="
                                            $router.push(
                                                '/branch-params-simulation/' +
                                                    item.id
                                            )
                                        "
                                        title="Editar parâmetros de loja"
                                    >
                                        <md-icon>storefront</md-icon>
                                    </md-button>
                                    <md-button
                                        class="md-just-icon md-danger md-simple"
                                        @click.native="
                                            $router.push(
                                                '/dc-params-simulation/' +
                                                    item.id
                                            )
                                        "
                                        title="Editar parâmetros de CD"
                                    >
                                        <md-icon>corporate_fare</md-icon>
                                    </md-button>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                    <div class="text-center mt--2 pb-2" v-else>
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
                <md-card-actions md-alignment="space-between">
                    <div class="">
                        <p class="card-category">
                            Mostrando <select id="numberItemPage" v-model="pagination.perPage">
                                <option value=20>20</option>
                                <option value=40>40</option>
                                <option value=60>60</option>
                                <option value=80>80</option>
                                <option value=100>100</option>
                            </select> itens de um total
                        de {{ total }}.
                        </p>
                    </div>
                    <pagination
                        class="pagination-no-border pagination-success"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="total"
                    >
                    </pagination>
                </md-card-actions>                
            </md-card>
        </div>
        <!-- Results -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-2">
                    <h4 class="title pt-1" v-if="!productLoading">
                        Resultados
                    </h4>
                </md-card-header>
                <md-card-content class="pb-2">
                    <div class="md-layout" v-if="!productLoading">
                        <div
                            class="md-layout-item md-size-33 md-small-size-100"
                        >
                            <highcharts
                                :constructor-type="'chart'"
                                :options="salesQtdBarsOptions"
                                class="chart"
                            ></highcharts>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100"
                        >
                            <highcharts
                                :constructor-type="'chart'"
                                :options="salesPriceBarsOptions"
                                class="chart"
                            ></highcharts>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100"
                        >
                            <highcharts
                                :constructor-type="'chart'"
                                :options="dispersionOptions"
                                class="chart"
                            ></highcharts>
                        </div>
                    </div>

                    <div class="text-center mt--2 pb-2" v-else>
                        <img
                            src="loader.svg"
                            style="width: 100px; height: 100px"
                        />
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <!-- Resume -->
        <div class="md-layout-item md-size-100">
            <md-card class="pl-1 pr-1">
                <md-card-header class="pb-2">
                    <h4 class="title pt-1" v-if="!productLoading">
                        Resumo do Sortimento
                    </h4>
                </md-card-header>
                <md-card-content class="pb-2">
                    <div class="md-layout">
                        <div
                            class="md-layout-item md-layout md-size-30 md-small-size-100 mb-1"
                        >
                            <div class="md-layout-item md-size-100 pr-0 pl-0">
                                <md-card class="mt-0 ml-0 mr-0 mb-1">
                                    <md-card-header>
                                        <b>Saúde da Categoria e Classe</b>
                                    </md-card-header>
                                    <md-card-content>
                                        <ul v-if="simulationSelected">
                                            <li
                                                :class="{
                                                    'color-danger':
                                                        assortmentAnalysis.items_obsolete >
                                                        0,
                                                    'color-success':
                                                        assortmentAnalysis.items_obsolete ==
                                                        0
                                                }"
                                            >
                                                {{
                                                    formatNumber(
                                                        assortmentAnalysis.items_obsolete,
                                                        'int',
                                                        true
                                                    )
                                                }}
                                                itens obsoletos
                                            </li>
                                            <li
                                                :class="{
                                                    'color-danger':
                                                        assortmentAnalysis.coverage >
                                                        stock_coverage_metas[
                                                            simulationSelected[
                                                                'curve'
                                                            ]
                                                        ],
                                                    'color-success':
                                                        assortmentAnalysis.coverage <=
                                                        stock_coverage_metas[
                                                            simulationSelected[
                                                                'curve'
                                                            ]
                                                        ]
                                                }"
                                            >
                                                {{
                                                    formatNumber(
                                                        assortmentAnalysis.coverage,
                                                        'int'
                                                    )
                                                }}
                                                dias de TC
                                            </li>
                                        </ul>
                                        <span v-else>
                                            Nenhuma simulação selecionada
                                        </span>
                                    </md-card-content>
                                </md-card>
                            </div>
                            <div class="md-layout-item md-size-100 pr-0 pl-0">
                                <md-card class="m-0">
                                    <md-card-header>
                                        <b>
                                            Itens C, CC e Obsoletos da Categoria
                                        </b>
                                    </md-card-header>
                                    <md-card-content>
                                        <ul v-if="simulationSelected">
                                            <li>
                                                R$
                                                {{
                                                    formatNumber(
                                                        assortmentAnalysis.total_ccc_obsolete_cost,
                                                        'int',
                                                        true
                                                    )
                                                }}
                                                em estoque
                                            </li>
                                            <!-- check if value deviates from 5% by 10%, 20% or more -->
                                            <li
                                                :class="{
                                                    'color-danger':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_cost /
                                                                    0.05
                                                        ) >= 0.2,
                                                    'color-warning':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_cost /
                                                                    0.05
                                                        ) < 0.2,
                                                    'color-success':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_cost /
                                                                    0.05
                                                        ) < 0.1
                                                }"
                                            >
                                                {{
                                                    formatNumber(
                                                        assortmentAnalysis.percente_ccc_obsolete_cost *
                                                            100,
                                                        'int'
                                                    )
                                                }}% do estoque em R$
                                            </li>
                                            <!-- check if value deviates from 5% by 10%, 20% or more -->
                                            <li
                                                :class="{
                                                    'color-danger':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_items /
                                                                    0.05
                                                        ) >= 0.2,
                                                    'color-warning':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_items /
                                                                    0.05
                                                        ) < 0.2,
                                                    'color-success':
                                                        Math.abs(
                                                            1 -
                                                                assortmentAnalysis.percente_ccc_obsolete_items /
                                                                    0.05
                                                        ) < 0.1
                                                }"
                                            >
                                                {{
                                                    formatNumber(
                                                        assortmentAnalysis.percente_ccc_obsolete_items *
                                                            100,
                                                        'int'
                                                    )
                                                }}% do estoque em UN
                                            </li>
                                        </ul>
                                        <span v-else>
                                            Nenhuma simulação selecionada
                                        </span>
                                    </md-card-content>
                                </md-card>
                            </div>
                        </div>
                        <div
                            class="md-layout-item md-layout md-size-30 md-small-size-100 mb-1"
                        >
                            <md-card class="m-0">
                                <md-card-header>
                                    <b>Análise da Dispersão de Lojas</b>
                                </md-card-header>
                                <md-card-content>
                                    <ul v-if="simulationSelected">
                                        <li class="mb-1">
                                            {{ countFirstQuadrant }} lojas no 1º
                                            quadrante
                                        </li>
                                        <li class="mb-1">
                                            {{ countSecondQuadrant }} lojas no
                                            2º quadrante
                                        </li>
                                        <li class="mb-1">
                                            {{ countThirdQuadrant }} lojas no 3º
                                            quadrante
                                        </li>
                                        <li class="mb-1">
                                            {{ countFourthQuadrant }} lojas no
                                            4º quadrante
                                        </li>
                                    </ul>
                                    <span v-else>
                                        Nenhuma simulação selecionada
                                    </span>
                                </md-card-content>
                            </md-card>
                        </div>
                        <div
                            class="md-layout-item md-layout md-size-40 md-small-size-100 mb-1"
                        >
                            <md-card class="m-0">
                                <md-card-header>
                                    <b>Observação da simulação</b>
                                </md-card-header>
                                <md-card-content>
                                    <span v-if="simulationSelected">
                                        {{
                                            assortmentAnalysis.observation
                                                ? assortmentAnalysis.observation
                                                : 'Não há observações'
                                        }}
                                    </span>
                                    <span v-else>
                                        Nenhuma simulação selecionada
                                    </span>
                                </md-card-content>
                            </md-card>
                        </div>
                    </div>
                </md-card-content>
            </md-card>
        </div>
        <div
            class="md-layout-item md-size-100"
            style="text-align: center"
            v-if="simulationSelected && approvalPermission"
        >
            <md-button @click="approvalModalOpen(true)">
                Aprovar Produto
            </md-button>
        </div>
        <!-- MODALS -->

        <!-- Modal Confirm changes -->
        <modal
            v-if="approvalModal"
            @close="approvalModalOpen(false)"
            width="500px"
        >
            <template slot="header">
                <h4 class="modal-title">Aprovar Produto</h4>
                <md-button
                    class="md-simple md-just-icon md-round modal-default-button"
                    @click="approvalModalOpen(false)"
                >
                    <md-icon>clear</md-icon>
                </md-button>
            </template>

            <template slot="body">
                <div class="md-layout">
                    <div
                        class="md-layout-item md-layout md-size-100 md-alignment-top-space-between"
                    >
                        <div class="md-layout-item md-size-100">
                            <b
                                >Confimar aprovação do Produto
                                {{ product.name }}? </b
                            ><br />
                            Resumo da Simulação selecionada: ID Simulação:
                            {{ simulationSelected.id }}, PVD 90D: R$
                            {{
                                formatNumber(
                                    simulationSelected.pvd_90_price,
                                    'float',
                                    true
                                )
                            }}, Custo Estoque 90D: R$
                            {{
                                formatNumber(
                                    simulationSelected.stock_cost,
                                    'float',
                                    true
                                )
                            }}, Curva: {{ simulationSelected.curve }}, TC:
                            {{ simulationSelected.coverage }}
                        </div>
                        <div class="md-layout-item md-size-100 ">
                            <md-field>
                                <label>
                                    Adicione uma ressalva (opcional):
                                </label>
                                <md-textarea v-model="caveat"></md-textarea>
                            </md-field>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <md-button class="md-simple" @click="approvalModalOpen(false)">
                    Voltar
                </md-button>
                <md-button class="md-primary" @click="approvalModalSubmit()">
                    <i
                        class="fas fa-spinner fa-spin"
                        v-if="approvalModalLoading"
                    ></i>
                    Confirmar
                </md-button>
            </template>
        </modal>
    </div>
    <div v-else>
        <div v-if="me">
            Você não pode acessar essa página
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import Utils from '@/utils'
import { mapState, mapActions } from 'vuex'
import { Product as Model } from '@/models/product.model'
import { ProductService } from '@/services/product.service'
import { SimulationService } from '@/services/simulation.service'
import { Pagination, Modal } from '@/components'

const model = 'products'

const defaultBarSeries = [
    {
        id: 'similar_re',
        name: 'Varejo Similar',
        data: [0, 0, 0],
        stack: 'similar_re',
        linkedTo: 'simulado',
        pointPlacement: -0.2
    },
    {
        id: 'similar_ws',
        name: 'Atacado Similar',
        data: [0, 0, 0],
        stack: 'similar',
        linkedTo: 'simulado_ws',
        pointPlacement: -0.2
    },
    {
        id: 'simulado_re',
        name: 'Varejo Simulado',
        data: [0, 0, 0],
        stack: 'simulado',
        dataLabels: [
            {
                enabled: true,
                inside: true,
                style: {
                    fontSize: '16px'
                }
            }
        ]
    },
    {
        id: 'simulado_ws',
        name: 'Atacado Simulado',
        data: [0, 0, 0],
        stack: 'simulado',
        dataLabels: [
            {
                enabled: true,
                inside: true,
                style: {
                    fontSize: '16px'
                }
            }
        ]
    }
]

export default {
    async created() {
        await this.readEntity(this.productId)
        if (this.product.similar_product)
            this.similarProduct = (
                await ProductService.readById(this.product.similar_product)
            ).data
        this.readSimulations() // allow click on simulation only after similar product is loaded
    },
    props: ['productId'],
    components: {
        Modal,
        Pagination
    },
    computed: {
        ...mapState({
            product: state => state[model].current,
            productLoading: state => state[model].currentLoading,
            simulations: state => state['simulations'].page,
            assortmentAnalysis: state =>
                state['simulations'].assortmentAnalysis,
            approvalModalLoading: state => state['simulations'].approvalLoading,
            me: state => state['auth'].me
        }),

        screenVisible() {
            if (this.me)
                return (
                    this.me.permissions.indexOf('simulations.view_simulation') >
                    -1
                )
            return false
        },

        approvalPermission() {
            if (this.me)
                return (
                    this.me.permissions.indexOf('simulations.can_approve') > -1
                )
            return false
        },

        currentStatus() {
            return this.status_obj[this.product.status]
        },

        currentVoltage() {
            return this.product.voltage && this.product.voltage != '0'
                ? this.product.voltage
                : 'SEM VOLTAGEM'
        },

        countFirstQuadrant() {
            if (!this.tcpvds) return 0

            return Object.keys(this.tcpvds)
                .flatMap(status => this.tcpvds[status])
                .filter(
                    a =>
                        a[0] <= this.dispersionXMean &&
                        a[1] >= this.dispersionYMean
                ).length
        },

        countSecondQuadrant() {
            if (!this.tcpvds) return 0

            return Object.keys(this.tcpvds)
                .flatMap(status => this.tcpvds[status])
                .filter(
                    a =>
                        a[0] <= this.dispersionXMean &&
                        a[1] < this.dispersionYMean
                ).length
        },

        countThirdQuadrant() {
            if (!this.tcpvds) return 0

            return Object.keys(this.tcpvds)
                .flatMap(status => this.tcpvds[status])
                .filter(
                    a =>
                        a[0] > this.dispersionXMean &&
                        a[1] >= this.dispersionYMean
                ).length
        },
        countFourthQuadrant() {
            if (!this.tcpvds) return 0

            return Object.keys(this.tcpvds)
                .flatMap(status => this.tcpvds[status])
                .filter(
                    a =>
                        a[0] > this.dispersionXMean &&
                        a[1] < this.dispersionYMean
                ).length
        },
        total() {
            return this.simulations.count
        }
    },
    data() {
        return {
            status_obj: {
                P: 'Candidato',
                A: 'Ativo',
                D: 'Em descontinuação',
                O: 'Descontinuado',
                I: 'Inativo'
            },
            columnNames: {
                id: 'ID',
                datetime_created: 'Data Simulação',
                pvd_90_price: 'PVD 90D',
                stock_cost: 'Custo Est. 90D',
                profit_margin: 'Margem Lucro',
                stock_count: 'Total Peças',
                curve: 'Curva'
            },
            currentSort: 'id',
            currentSortOrder: 'asc',
            simulationsLoading: false,
            actionVisible: null,

            similarProduct: null,
            simulationSelected: null,
            salesPriceBarsOptions: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Faturamento dos três primeiros meses de venda'
                },
                xAxis: {
                    categories: [1, 2, 3],
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Faturamento'
                    },
                    showFirstLabel: false
                },
                tooltip: {
                    shared: true,
                    headerFormat:
                        '<span style="font-size: 15px">{point.point.name}</span><br/>',
                    pointFormat:
                        '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
                },
                plotOptions: {
                    column: {
                        stacking: 'normal'
                    },
                    series: {
                        grouping: false,
                        borderWidth: 0
                    }
                },
                series: defaultBarSeries
            },
            salesQtdBarsOptions: {
                chart: {
                    type: 'column'
                },
                title: {
                    text: 'Total de peças dos três primeiros meses de venda'
                },
                xAxis: {
                    categories: [1, 2, 3],
                    crosshair: true
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Total de Peças'
                    }
                },
                tooltip: {
                    headerFormat:
                        '<span style="font-size:10px">{point.key}</span><table>',
                    pointFormat:
                        '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                        '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
                    footerFormat: '</table>',
                    shared: true,
                    useHTML: true
                },
                plotOptions: {
                    column: {
                        stacking: 'normal'
                    },
                    series: {
                        grouping: false,
                        borderWidth: 0
                    }
                },
                series: defaultBarSeries
            },
            dispersionXMean: 0,
            dispersionYMean: 0,
            tcpvds: null,
            dispersionOptions: {
                chart: {
                    type: 'scatter',
                    zoomType: 'xy'
                },
                title: {
                    text: 'Dispersão de Lojas por TC e Faturamento'
                },
                xAxis: {
                    title: {
                        enabled: true,
                        text: 'Tempo de Cobertura'
                    },
                    startOnTick: true,
                    endOnTick: true,
                    showLastLabel: true,
                    events: {
                        afterSetExtremes: e => {
                            this.dispersionXMean = (e.max + e.min) / 2
                        }
                    }
                },
                yAxis: {
                    title: {
                        text: 'Faturamento'
                    },
                    events: {
                        afterSetExtremes: e => {
                            this.dispersionYMean = (e.max + e.min) / 2
                        }
                    }
                },
                plotOptions: {
                    scatter: {
                        marker: {
                            radius: 5,
                            states: {
                                hover: {
                                    enabled: true,
                                    lineColor: 'rgb(100,100,100)'
                                }
                            }
                        },
                        states: {
                            hover: {
                                marker: {
                                    enabled: false
                                }
                            }
                        },
                        tooltip: {
                            headerFormat: '<b>{series.name}</b><br>',
                            pointFormat: '{point.x} dias, {point.y} R$'
                        }
                    }
                },
                series: [
                    {
                        name: 'Padrão',
                        color: 'rgba(119, 152, 191, .5)',
                        data: []
                    },
                    {
                        name: 'Modificado',
                        color: 'rgba(223, 191, 83, .5)',
                        data: []
                    },
                    {
                        name: 'Removido',
                        color: 'rgba(223, 83, 83, .5)',
                        data: []
                    },
                    {
                        name: 'Removido Manualmente',
                        color: 'rgba(191, 83, 191, .5)',
                        data: []
                    }
                ]
            },

            caveat: null,

            approvalModal: false,

            stock_coverage_metas: {
                AA: 20,
                A: 30,
                B: 35,
                C: 40,
                CC: 40
            },
            pagination: {
                perPage: 20,
                currentPage: 1,
                total: 0
            }
        }
    },
    methods: {
        ...mapActions(model, {
            readEntity: 'readById'
        }),
        ...mapActions('simulations', {
            _readSimulations: 'read',
            readAssortmentAnalysis: 'readAssortmentAnalysisById',
            approveSimulation: 'approve'
        }),

        approvalModalOpen(state) {
            this.approvalModal = state
        },

        formatNumber: (number, type, shorten) =>
            Utils.formatNumber(number, type, shorten),

        async readSimulations() {
            this.simulationsLoading = true
            try {
                await this._readSimulations({ product: this.productId })
            } catch (e) {
                Swal.fire({
                    title: 'Ocorreu um erro!',
                    text:
                        'Não foi possível criar uma simulação. Verifique se existem parâmetros para este produto ou peça ajuda a um desenvolvedor.',
                    type: 'info',
                    showCancelButton: false,
                    confirmButtonClass: 'md-button md-simple btn-fill',
                    confirmButtonText: 'Voltar aos produtos',
                    buttonsStyling: false
                }).then(async result => {
                    this.$router.push('/products')
                })
            }
            this.simulationsLoading = false
        },

        async selectSimulation(simulation) {
            this.simulationSelected = simulation

            // sales price
            this.salesPriceBarsOptions.series = Utils.deepCopy(defaultBarSeries) // reset chart
            this.salesPriceBarsOptions.series[2].data = [
                Utils.roundNumber(this.simulationSelected.pvd_30_price_re),
                Utils.roundNumber(this.simulationSelected.pvd_60_price_re),
                Utils.roundNumber(this.simulationSelected.pvd_90_price_re)
            ]
            this.salesPriceBarsOptions.series[3].data = [
                Utils.roundNumber(this.simulationSelected.pvd_30_price_ws),
                Utils.roundNumber(this.simulationSelected.pvd_60_price_ws),
                Utils.roundNumber(this.simulationSelected.pvd_90_price_ws)
            ]

            // sales quantity
            this.salesQtdBarsOptions.series = Utils.deepCopy(defaultBarSeries) // reset chart
            this.salesQtdBarsOptions.series[2].data = [
                Utils.roundNumber(this.simulationSelected.pvd_30_re),
                Utils.roundNumber(this.simulationSelected.pvd_60_re),
                Utils.roundNumber(this.simulationSelected.pvd_90_re)
            ]
            this.salesQtdBarsOptions.series[3].data = [
                Utils.roundNumber(this.simulationSelected.pvd_30_ws),
                Utils.roundNumber(this.simulationSelected.pvd_60_ws),
                Utils.roundNumber(this.simulationSelected.pvd_90_ws)
            ]

            if (this.similarProduct) {
                // sales price
                this.salesPriceBarsOptions.series[0].data = [
                    Utils.roundNumber(this.similarProduct.pvd_30_price_re),
                    Utils.roundNumber(this.similarProduct.pvd_60_price_re),
                    Utils.roundNumber(this.similarProduct.pvd_90_price_re)
                ]
                this.salesPriceBarsOptions.series[1].data = [
                    Utils.roundNumber(this.similarProduct.pvd_30_price_ws),
                    Utils.roundNumber(this.similarProduct.pvd_60_price_ws),
                    Utils.roundNumber(this.similarProduct.pvd_90_price_ws)
                ]

                // sales quantity e
                this.salesQtdBarsOptions.series[0].data = [
                    Utils.roundNumber(this.similarProduct.pvd_30_re),
                    Utils.roundNumber(this.similarProduct.pvd_60_re),
                    Utils.roundNumber(this.similarProduct.pvd_90_re)
                ]
                this.salesQtdBarsOptions.series[1].data = [
                    Utils.roundNumber(this.similarProduct.pvd_30_ws),
                    Utils.roundNumber(this.similarProduct.pvd_60_ws),
                    Utils.roundNumber(this.similarProduct.pvd_90_ws)
                ]
            }

            this.readAssortmentAnalysis(this.simulationSelected.id)
            let tcpvds = (
                await SimulationService.readTCvsPVDs(this.simulationSelected.id)
            ).data

            this.tcpvds = tcpvds
            this.dispersionOptions.series[0].data = tcpvds['default']
            this.dispersionOptions.series[1].data = tcpvds['modified']
            this.dispersionOptions.series[2].data = tcpvds['removed']
            this.dispersionOptions.series[3].data = tcpvds['removed_man']
        },

        customSort(value) {
            return value.sort((a, b) => {
                const sortBy = this.currentSort
                try {
                    if (this.currentSortOrder === 'desc')
                        return a[sortBy].localeCompare(b[sortBy])
                    return b[sortBy].localeCompare(a[sortBy])
                } catch (e) {
                    return 0
                }
            })
        },
        async approvalModalSubmit() {
            if (this.simulationSelected) {
                let result = await this.approveSimulation({
                    id: this.simulationSelected.id,
                    caveat: this.caveat
                })
                if (!result) {
                    this.approvalModalOpen(false)
                } else {
                    this.$notify({
                        message: 'Erro ao aprovar produto.',
                        icon: 'add_alert',
                        horizontalAlign: 'right',
                        verticalAlign: 'bottom',
                        type: 'danger'
                    })
                }
            }
        }
    },
    watch: {
        pagination: {
            handler: function(val) {
                if (val.perPage) val.perPage = parseInt(val.perPage)
                this._readSimulations({ 
                    product: this.productId,
                    page: val.currentPage,
                    limit: val.perPage                    
                    })
            },
            deep: true
        }
    }    
}
</script>

<style lang="scss" scoped>
.image-content {
    text-align: center;
    min-width: 200px;
}

.list-content {
    .item-content {
        float: right;
    }
}
.simulation-row {
    cursor: pointer;

    &.simulation-selected {
        background-color: #3c8db9;
        color: #fff;
    }
}

.color-success {
    color: #080;
}
.color-warning {
    color: #770;
}
.color-danger {
    color: #a00;
}
</style>
